// @flow
//eslint-disable-next-line

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { MANAGE_CART_HELPER, APP_HELPER, HISTORY, ROUTE_CONSTANTS } from '../../../utils'
import { useTranslation } from '../../../hooks'
import { CONFIG_CONSTANTS } from '../../../store/actionTypes'

function PaymentSummary() {
	const dispatch = useDispatch()
	const translate = useTranslation()
	const { sub_total_amount } = useSelector((state) => state.cart.cart_items)
	const { custom_catalog, catalogue_key } = useSelector((state) => state.config)
	const { currency_code } = useSelector((state) => state.config.merchant)

	const showReceiptInfo = (translation_key, value) => {
		return (
			<>
				<p>{translate(translation_key)}:</p>
				<p className="totalVal" dir={APP_HELPER.GET_LANG_DIRECTION()}>
					{MANAGE_CART_HELPER.formatCharges(currency_code, value ?? 0)}
				</p>
			</>
		)
	}

	const handleViewCatalog = () => {
		if (!custom_catalog) {
			dispatch({ type: CONFIG_CONSTANTS.CLEAR_SELECTED_CATEGORY })
			HISTORY.push('/' + catalogue_key)
		} else {
			HISTORY.push(ROUTE_CONSTANTS.BASE)
		}
	}

	return (
		<div className="paymentSummary">
			<div className="cartTopButton">
				<button
					className="generalCartSlideBtn"
					onClick={() => {
						handleViewCatalog()
					}}
				>
					<i className="new-icon-category cartBtnIcon"></i>
					<span>{translate('CART.GENERAL_BTNS.CATLAOG_BTN')}</span>
				</button>
			</div>
			<div className="payment-summry-btn">{translate('CART.GENERAL_BTNS.PAYMENT_SUMMARY')}</div>
			<div className="inner-sec">
				<div className="count">
					<div className="count-child" key={1}>
						{showReceiptInfo('CART.SUB_TOTAL', sub_total_amount)}
					</div>
					<div className="count-child totalPaymentWrap">
						<p className="total">{translate('CART.TOTAL')}:</p>
						<p className="total-price totalVal" dir={APP_HELPER.GET_LANG_DIRECTION()}>
							{MANAGE_CART_HELPER.formatCharges(currency_code, sub_total_amount)}
						</p>
					</div>
				</div>
				{/*
                <div className="icons paymentIconsWrap">
                    <p>{translate("CART.GENERAL_BTNS.PAYMENT_METHODS")}</p>
                   {!HELPER.isEmpty(payment_icon) ? <span>
                        <img src={payment_icon} alt="payment-icons" />
                    </span> : ""}
                </div>
                 */}
			</div>
		</div>
	)
}

export default PaymentSummary
